module.exports = __webpack_public_path__ + "media/bootstrap-icons/align-top-0207013a.svg";